import React from "react";

const BDPaxInfo = ({ bookingDetails }) => {
  return (
    <>
      {bookingDetails?.lineItems?.length > 0 && (
        <div className="bd-p-pax-info col-lg-5 col-12">
          <h5 className="bd-p-pax-info-title">Quantity (no of Pax)</h5>
          {bookingDetails?.lineItems?.map((item) => (
            <div className="pax-item bd-p-header-date">
              <span>
                <strong className="bd-p-pax-info-title">
                  {item?.quantity}{" "}
                </strong>
                {item?.pax_type_name}
              </span>
              <span>AED {parseInt(item?.unit_price)}</span>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default BDPaxInfo;
